import * as Types from '../constants/Types';

export const dataTourTicketAction = (filters) => ({ type: Types.TOUR_TICKET_LIST_ACTION, filters });
export const dataTourTicketSuccess = (tourTickets) => ({ type: Types.TOUR_TICKET_LIST_SUCCESS, tourTickets });

export const createTourTicketAction = (params) => ({ type: Types.TOUR_TICKET_CREATE_ACTION, params });
export const deleteTourTicketAction = (params) => ({ type: Types.TOUR_TICKET_DELETE_ACTION, params });

export const getUpdateTourTicketAction = (params) => ({ type: Types.TOUR_TICKET_GET_UPDATE_ACTION, params });
export const getUpdateTourTicketSuccess = (tourTicket) => ({ type: Types.TOUR_TICKET_GET_UPDATE_SUCCESS, tourTicket });
export const updateTourTicketAction = (params) => ({ type: Types.TOUR_TICKET_UPDATE_ACTION, params });

export const createTourTicketTranslate = (tourTicket) => ({ type: Types.TOUR_TICKET_CREATE_TRANSLATE_ACTION, tourTicket });
export const updateTourTicketTranslate = (tourTicket) => ({ type: Types.TOUR_TICKET_UPDATE_TRANSLATE_ACTION, tourTicket });
export const deleteTourTicketTranslate = (tourTicket, refreshParams) => ({ type: Types.TOUR_TICKET_DELETE_TRANSLATE_ACTION, tourTicket, refreshParams });

export const resetTourTicket = () => ({ type: Types.TOUR_TICKET_RESET });

export const checkTourTicketAction = (serialNumber) => ({ type: Types.TOUR_TICKET_CHECK_ACTION, serialNumber });
export const checkTourTicketSuccess = (resultCheck) => ({ type: Types.TOUR_TICKET_CHECK_SUCCESS, resultCheck });
export const checkTourTicketFailAction = (params) => ({ type: Types.TOUR_TICKET_CHECK_FAIL, params });
export const tourTicketReset = () => ({ type: Types.TOUR_TICKET_RESET });

export const getAllTickets = () => ({ type: Types.TOUR_TICKET_LIST_ALL_ACTION });
export const setAllTickets = (tickets) => ({ type: Types.TOUR_TICKET_LIST_ALL_SUCCESS, tickets });

export const getAllTicketsById = (id) => ({ type: Types.TOUR_TICKET_LIST_ALL_BY_ID_ACTION, id });
export const setAllTicketsById = (tickets) => ({ type: Types.TOUR_TICKET_LIST_ALL_BY_ID_SUCCESS, tickets });
